import { defineComponent as _defineComponent } from 'vue'
import {
  ApprovalShift,
  ApprovalEarlytimeUser
} from "@/models/approval/ApprovalResponse";
import { DateTime } from "luxon";
import { DataTableHeader } from "vuetify";
import ApprovalChip from "../table/ApprovalChip.vue";
import TimeList from "@/components/list/TimeList.vue";
import { EarlytimeFlowDat } from "@/models/transaction/EarlytimeFlowDat";

type Props = {
  dat: EarlytimeFlowDat;
  approvals: ApprovalEarlytimeUser[];
  shift: ApprovalShift;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'EarlytimeExpandItem',
  props: {
    dat: null,
    approvals: null,
    shift: null
  },
  setup(__props: any) {

const shiftHeader = [
  { text: "開始時間： ", value: "startTime" },
  { text: "終了時間： ", value: "endTime" },
  { text: "総休憩時間： ", value: "breakTime" },
  { text: "早朝休憩時間： ", value: "morningBreakTime" },
  { text: "深夜休憩時間： ", value: "midnightBreakTime" },
  { text: "OPE時間： ", value: "opeTime" }
] as const;

const approvalHeaders: DataTableHeader[] = [
  { text: "承認日", value: "approvalDate", divider: true },
  { text: "承認ユーザ", value: "approvalUserName", divider: true },
  {
    text: "承認状態",
    value: "approvalFlag",
    divider: true,
    align: "center",
    sortable: false,
    width: 100
  }
];

const formatDateTime = (date: string) => {
  return DateTime.fromISO(date)
    .setLocale("ja")
    .toFormat("yyyy年MM月dd日(EEE) HH:mm:ss");
};


const displayStatus = (item: any) => {
  let val = "";
  if (item.isEarlytime) {
    if (item.applicationBy != null) {
      val = "特別申請者:\n" + "   " + item.applicationBy;
      return val;
    }
  } else {
    if (item.aid != "" && item.aid != undefined) val = "勤務時間";
    if (item.oid != "" && item.oid != undefined) {
      if (val != "") val = val + ",";
      val = val + "残業";
    }
    if (item.sid != "" && item.sid != undefined) {
      if (val != "") val = val + ",";
      val = val + "シフト";
    }
    if (item.vid != "" && item.vid != undefined) {
      if (val != "") val = val + ",";
      val = val + "休暇";
    }
    if (item.eid != "" && item.eid != undefined) {
      if (val != "") val = val + ",";
      val = val + "早出";
    }
    if (val != "") val = "申請 : " + val + "申請";
    return val;
  }
};

return { __sfc: true,shiftHeader, approvalHeaders, formatDateTime, displayStatus, ApprovalChip, TimeList }
}

})